// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RepliedMessage__miniature-a839cc {
  min-width: var(--message-bubble-min-width);
  max-width: var(--max-width-input-top-panel);
  width: 100%;
}

.RepliedMessage__icon-a22412 {
  fill: var(--base-60);
  flex-shrink: 0;
  margin-inline-end: 20px;
}

:root[dir=rtl] .RepliedMessage__icon-a22412 {
  transform: scaleX(-1);
}

.RepliedMessage__title-a234fb {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--brand-primary-40);
}

.RepliedMessage__remove-a39ede {
  color: var(--base-60);
  margin-inline-start: 12px;
}

.RepliedMessage__miniature-title-b1c1a6 {
  color: var(--brand-primary-40);
}

.RepliedMessage__miniature-text-e68d75 {
  color: var(--base-80);
}

.RepliedMessage__miniature-icon-e8a4f9 {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/RepliedMessage/RepliedMessage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,2CAAA;EACA,WAAA;AACF;;AAEA;EACE,oBAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,8BAAA;AACF;;AAEA;EACE,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".miniature {\n  min-width: var(--message-bubble-min-width);\n  max-width: var(--max-width-input-top-panel);\n  width: 100%;\n}\n\n.icon {\n  fill: var(--base-60);\n  flex-shrink: 0;\n  margin-inline-end: 20px;\n}\n\n:root[dir='rtl'] .icon {\n  transform: scaleX(-1);\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--brand-primary-40);\n}\n\n.remove {\n  color: var(--base-60);\n  margin-inline-start: 12px;\n}\n\n.miniature-title {\n  color: var(--brand-primary-40);\n}\n\n.miniature-text {\n  color: var(--base-80);\n}\n\n.miniature-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"miniature": `RepliedMessage__miniature-a839cc`,
	"icon": `RepliedMessage__icon-a22412`,
	"title": `RepliedMessage__title-a234fb`,
	"remove": `RepliedMessage__remove-a39ede`,
	"miniature-title": `RepliedMessage__miniature-title-b1c1a6`,
	"miniatureTitle": `RepliedMessage__miniature-title-b1c1a6`,
	"miniature-text": `RepliedMessage__miniature-text-e68d75`,
	"miniatureText": `RepliedMessage__miniature-text-e68d75`,
	"miniature-icon": `RepliedMessage__miniature-icon-e8a4f9`,
	"miniatureIcon": `RepliedMessage__miniature-icon-e8a4f9`
};
module.exports = ___CSS_LOADER_EXPORT___;
